import validator from 'validator';
import A from 'actions/passwordResetActions';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ Request } = ssCommonUtils,
init = {
    request: new Request(),
    passwordUpdateRequest: new Request(),
    expiredPasswordUpdateRequest: new Request(),
    emailUpdateRequest: new Request(),
    checkTokenRequest: new Request(),
    showPasswordResetModal: false,
    expirationId: '',
    emailId: '',
    oldPassword: '',
    passwordMatch: false,
    newPassword1: { password: '', valid: false },
    newPassword2: { password: '', valid: false },
    emailAddress1: { email: '', valid: false },
    emailAddress2: { email: '', valid: false },
    passportNumber: '',
    passportCountry: '',
    securityQuestion1: '',
    securityQuestion2: '',
    securityQuestion3: '',
    validToken: null
};

export default (state=init, action) => { switch(action.type) {
    default: return {...state};

    case A.HOME_TOGGLE_PASSWORD_RESET_MODAL:
        return {...state, showPasswordResetModal: !state.showPasswordResetModal };

    case A.HOME_RESET_PASSWORD_RESET_REQUEST:
        return {...state, request: new Request() };

    case A.HOME_PENDING_PASSWORD_RESET_REQUEST:
        return {...state, request: {...state.request, status: 'pending' }};

    case A.HOME_SUCCESS_PASSWORD_RESET_REQUEST:
        return {...state, request: {...state.request, status: 'success' }};

    case A.HOME_FAILURE_PASSWORD_RESET_REQUEST:
        return {...state, request: {...state.request, status: 'failure' }};

    case A.HOME_CLEAR_REQUEST_PASSWORD_RESET:
        return {...state, request: new Request() };

    case A.HOME_UPDATE_RESET_FIELD:
        return ((state, field, value) => { switch(field) {
            case 'emailId': return {...state, emailId: value };
            case 'expirationId': return {...state, expirationId: value };
            case 'oldPassword': return {...state, oldPassword: value };
            case 'newPassword1': return {...state,
                passwordMatch: value === state.newPassword2 ? true : false,
                newPassword1: {...state.newPassword1,
                    password: value,
                    valid: passwordRules(value, [])
                }
            };
            case 'newPassword2': return {...state,
                passwordMatch: value === state.newPassword1 ? true : false,
                newPassword2: {...state.newPassword2,
                    password: value,
                    valid: passwordRules(value, [])
                }
            };
            case 'emailAddress1': return {...state, emailAddress1: {...state.emailAddress1,
                    email: value,
                    valid: passwordRules(value, [ 'isEmail' ])
            }};
            case 'emailAddress2': return {...state, emailAddress2: {...state.emailAddress2,
                    email: value,
                    valid: passwordRules(value, [ 'isEmail' ])
            }};
            case 'passportNumber': return {...state, passportNumber: value };
            case 'passportCountry': return {...state, passportCountry: value };
            case 'securityQuestion1': return {...state, securityQuestion1: value };
            case 'securityQuestion2': return {...state, securityQuestion2: value };
            case 'securityQuestion3': return {...state, securityQuestion3: value };
        }})(state, action.payload.field, action.payload.value)

    case A.HOME_CLEAR_RESET_FIELD:
        return ((state, field) => { switch(field) {
            case 'emailId': return {...state, emailId: '' };
            case 'expirationId': return {...state, expirationId: value };
            case 'oldPassword': return {...state, oldPassword: '' };
            case 'newPassword1': return {...state, newPassword1: {...state.newPassword1,
                password: '',
                valid: false
            }};
            case 'newPassword1': return {...state,  newPassword2: {...state.newPassword2,
                password: '',
                valid: false
            }};
            case 'emailAddress1': return {...state, emailAddress1: {...state.emailAddress1,
                    email: '',
                    valid: false
            }};
            case 'emailAddress2': return {...state, emailAddress2: {...state.emailAddress2,
                    email: '',
                    valid: false
            }};
            case 'passportNumber': return {...state, passportNumber: '' };
            case 'passportCountry': return {...state, passportCountry: '' };
            case 'securityQuestion1': return {...state, securityQuestion1: '' };
            case 'securityQuestion2': return {...state, securityQuestion2: '' };
            case 'securityQuestion3': return {...state, securityQuestion3: '' };
        }})(state, action.payload)

    case A.HOME_UPDATE_PROPS:
        return ((state, field, props) => { switch(field) {
            case 'oldPassword': return {...state, oldPassword: {...state.oldPassword, props: props }};
            case 'newPassword1': return {...state, newPassword1: {...state.newPassword1, props: props }};
            case 'newPassword2': return {...state, newPassword2: {...state.newPassword2, props: props }};
        }})(state, action.payload.field, action.payload.props)

    case A.HOME_PENDING_UPDATE_NEW_PASSWORD:
        return {...state, passwordUpdateRequest: {...state.passwordUpdateRequest, status: 'pending' }};

    case A.HOME_SUCCESS_UPDATE_NEW_PASSWORD:
        return {...state, passwordUpdateRequest: {...state.passwordUpdateRequest, status: 'success' }};

    case A.HOME_FAILURE_UPDATE_NEW_PASSWORD:
        return {...state, passwordUpdateRequest: {...state.passwordUpdateRequest,
            status: 'failure',
            code: action.payload.status
        }};

    case A.HOME_RESET_UPDATE_NEW_PASSWORD_REQUEST:
        return {...state, passwordUpdateRequest: new Request() };

    case A.HOME_PENDING_UPDATE_EXPIRED_PASSWORD:
        return {...state, expiredPasswordUpdateRequest: {...state.expiredPasswordUpdateRequest, status: 'pending' }};

    case A.HOME_SUCCESS_UPDATE_EXPIRED_PASSWORD:
        return {...state, expiredPasswordUpdateRequest: {...state.expiredPasswordUpdateRequest, status: 'success' }};

    case A.HOME_FAILURE_UPDATE_EXPIRED_PASSWORD:
        return {...state, expiredPasswordUpdateRequest: {...state.expiredPasswordUpdateRequest,
            status: 'failure',
            code: action.payload.status
        }};

    case A.HOME_RESET_UPDATE_EXPIRED_PASSWORD_REQUEST:
        return {...state, expiredPasswordUpdateRequest: new Request() };

    case A.HOME_PENDING_UPDATE_NEW_EMAIL:
        return {...state, emailUpdateRequest: {...state.emailUpdateRequest, status: 'pending' }};

    case A.HOME_SUCCESS_UPDATE_NEW_EMAIL:
        return {...state, emailUpdateRequest: {...state.emailUpdateRequest, status: 'success' }};

    case A.HOME_FAILURE_UPDATE_NEW_EMAIL:
        return {...state, emailUpdateRequest: {...state.emailUpdateRequest,
            status: 'failure',
            code: action.payload.status
        }};

    case A.HOME_RESET_UPDATE_EMAIL_UPDATE_REQUEST:
        return {...state, emailUpdateRequest: new Request() };

    case A.CHECK_EXPIRED_REQUEST:
        return  {...state, checkTokenRequest: {...state.checkTokenRequest, status: 'pending' }};
    case A.CHECK_EXPIRED_SUCCESS:
        return  {...state, checkTokenRequest: {...state.checkTokenRequest,
            validToken: true,
            status: 'success' }};
    case A.CHECK_EXPIRED_FAILURE:
        return {...state, checkTokenRequest: {...state.checkTokenRequest,
            validToken: false,
            status: 'failure',
            code: action.payload.status
        }};
}}

const passwordRules = (v, r) => {
    let isValid = true;
    const rules = {
        isEmail: e => validator.isEmail(e)
    };

    for(let i=0; i < r.length; i++) {
        for(let p in rules)
            if(p === r[i])
                isValid = rules[p](v);
        if(!isValid) return false;
    }

    return true;
}
